module.exports = __webpack_public_path__ + "img/paibei_3452a076d.png";